<template>
  <FourElement></FourElement>
  <div class="collection-container">
    <List></List>
    <AddModal></AddModal>
  </div>
</template>

<script>
import FourElement from './components/FourElement.vue'
import List from './components/List.vue'
import AddModal from './components/AddModal.vue'
import { toRefs, reactive, provide, onMounted } from 'vue'
import dayjs from 'dayjs'
import {
  queryPageLiveCoupon,
  addLiveCoupon,
  updateLiveCoupon,
  deleteLiveCoupon,
  queryAllLiveRooms
} from 'server/modules/live'
import { common_lang_getAll } from 'server/modules/3426'
// import useAPI from 'UseApi'
// const { common_querySiteInfo_get_ } = useAPI(null, [3426])
import { message } from 'ant-design-vue'
export default {
  components: {
    FourElement,
    List,
    AddModal
  },
  setup() {
    const state = reactive({
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        }
      },
      //表格数据
      dataSource: [],
      //直播间数据
      liveRoomSelect: [],
      brands: [],
      channels: [],
      sites: [],
      //语言数据
      langList: [],
      //列
      columns: [
        {
          title: '序号',
          align: 'center',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '优惠券优惠金额',
          dataIndex: 'content',
          key: 'content',
          align: 'center'
        },
        {
          title: '优惠券使用门槛',
          align: 'center',
          dataIndex: 'remark',
          key: 'remark'
        },
        {
          title: '直播间',
          align: 'center',
          dataIndex: 'liveName',
          key: 'liveName'
        },
        {
          title: '券码',
          dataIndex: 'couponCode',
          key: 'couponCode',
          align: 'center'
        },
        {
          title: '券有效期',
          dataIndex: 'expStartDate',
          key: 'expStartDate',
          align: 'center'
        },
        {
          title: '发放规则',
          dataIndex: 'countDown',
          key: 'countDown',
          align: 'center'
        },
        {
          title: '发送时间',
          dataIndex: 'sendTime',
          key: 'sendTime',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      initList: () => {
        state.getTabList()
        state.getLiveRoomList()
        state.initCommonLang()
      },
      //table数据
      getTabList: () => {
        const param = {
          pageNum: state.pagination.current,
          pageSize: state.pagination.pageSize
        }
        queryPageLiveCoupon(param)
          .then(e => {
            if (e.success) {
              state.dataSource = e.data.data.list.records
              state.pagination.total = e.data.data.total
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      getLiveRoomList() {
        queryAllLiveRooms()
          .then(e => {
            if (e.success) {
              state.liveRoomSelect = e.data.data
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      initCommonLang: async () => {
        const param = {
          pageNum: 1,
          pageSize: 100
        }
        const { data } = await common_lang_getAll(param)
        const list = []
        data.list.map(item => {
          list.push({
            label: item.langCn,
            value: item.langCode
          })
        })
        state.langList = list
      },
      modalVisible: false,
      formRef: null,
      form: {
        remark: [
          {
            key: undefined,
            value: undefined
          }
        ]
      },
      //校验
      rules: {
        content: [{ required: true, message: '请输入优惠金额！' }],
        // remark: [{ required: true, message: '请输入使用门槛！' }],
        couponCode: [{ required: true, message: '请输入使券码！' }],
        countDown: [{ required: true, message: '请输入倒计时！' }],
        emptyTime: [{ required: true, message: '请输入有效期！' }],
        liveId: [{ required: true, message: '请选择直播间！' }]
      },
      add: () => {
        state.modalVisible = true
      },
      changeRangePicker() {
        state.form.expStartDate =
          state.form.emptyTime !== null
            ? dayjs(state.form.emptyTime[0]).format('YYYY-MM-DD')
            : ''
        state.form.expEndDate =
          state.form.emptyTime !== null
            ? dayjs(state.form.emptyTime[1]).format('YYYY-MM-DD')
            : ''
      },
      selectType() {
        if (state.form.sendTimeType === '1') {
          state.form.sendTime = ''
          console.log(state.form.sendTime)
        }
      },
      addContent() {
        state.form.remark.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.remark)
      },
      removeContent: info => {
        if (state.form.remark.length > 1) {
          const index = state.form.remark.indexOf(info)
          if (index !== -1) {
            state.form.remark.splice(index, 1)
          }
        }
      },
      modalCancel: () => {
        state.formRef.clearValidate()
        state.form = {
          remark: [
            {
              key: undefined,
              value: undefined
            }
          ]
        }
        state.modalVisible = false
      },
      modalSubmit: async () => {
        state.formRef
          .validateFields()
          .then(() => {
            const param = {
              ...state.form
            }
            if (param.sendTimeType === '1') {
              param.sendTime = null
            } else {
              param.sendTime = dayjs(param.sendTime).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            }
            param.remark = JSON.stringify(param.remark)
            if (param.id) {
              updateLiveCoupon(param)
                .then(e => {
                  if (e.success) {
                    message.success('更新成功')
                    state.formRef.clearValidate()
                    state.form = {
                      remark: [
                        {
                          key: undefined,
                          value: undefined
                        }
                      ]
                    }
                    state.modalVisible = false
                    state.initList()
                  } else {
                    message.warning(e.data)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            } else {
              addLiveCoupon(param)
                .then(e => {
                  if (e.success) {
                    if (e.data.succes) {
                      message.success('添加成功')
                      state.formRef.clearValidate()
                      state.form = {
                        remark: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ]
                      }
                      state.modalVisible = false
                      state.initList()
                    } else {
                      message.warning(e.data.data)
                    }
                  } else {
                    message.warning(e.retInfo)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            }
          })
          .catch(e => {
            console.log('e: ', e)
          })
      },
      handleEdit: info => {
        if (info) {
          state.form = {
            ...info,
            emptyTime: [dayjs(info.expStartDate), dayjs(info.expEndDate)],
            sendTime: info.immediately === 1 ? dayjs(info.sendTime) : '',
            sendTimeType: info.immediately === 0 ? '1' : '2',
            remark: JSON.parse(info.remark)
          }
          state.modalVisible = true
        }
      },
      handleDel: info => {
        if (info) {
          deleteLiveCoupon(info)
            .then(e => {
              if (e.success) {
                message.success('删除成功')
                state.initList()
              } else {
                message.warning(e.data)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      }
    })
    onMounted(() => {
      // common_querySiteInfo_get_({
      //   state
      // })
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
